module.exports = __webpack_public_path__ + "img/back.3dd8f705.svg";